import { render, staticRenderFns } from "./onTrialLabel.vue?vue&type=template&id=7b267a3a&scoped=true&"
import script from "./onTrialLabel.vue?vue&type=script&lang=js&"
export * from "./onTrialLabel.vue?vue&type=script&lang=js&"
import style0 from "./onTrialLabel.vue?vue&type=style&index=0&id=7b267a3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b267a3a",
  null
  
)

export default component.exports